import styled from "styled-components";

export const LastLoginValueDefaultBox = styled.div`
    font-size: 1rem;
    font-weight: 500;
    white-space: nowrap;
`;

export const LastLoginValueBox = LastLoginValueDefaultBox;